import React from 'react';
import { Tag, Stack } from 'rsuite';

export const EsatusStack = (props) => {
  const { estatus, validationResult, otherValidationsResult } = props;

  if(!validationResult.isValid)
    return <Tag color="red">DTE No Válido</Tag>
  
  if(otherValidationsResult)
  if(!otherValidationsResult.isValid)
    return <Tag color="red">DTE No Válido</Tag>

  if(estatus.estatusVigencia === 3)
    return (<Tag color="red">Este DTE ha sido anulado</Tag>)

  if(estatus.estatusFirmado === 2)
    return (<Tag color="red">Error de firma</Tag>)

  if(estatus.estatusRecibidoMH === 2 || estatus.estatusRecibidoMH === 0)
    return (<Tag color="red">Error Recepción MH</Tag>)  

  return (
    <Stack wrap spacing={6}>
      {
        {
          3: <Tag color="orange">Recepción diferida</Tag>,
        }[estatus.estatusRecibidoMH]
      }
      {
        {
          0: <Tag color="orange">No Notificado</Tag>,
          2: <Tag color="red">No Notificado</Tag>,
        }[estatus.estatusCorreo]
      }   
      {
        {
          1: <Tag color="green">DTE Válido</Tag>,
        }[estatus.estatusVigencia]
      }         
    </Stack>
  );
};
